import React from "react";
import { useMemo } from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useSalaryAdvanceListStore } from "../../../../Store/CashControlStore/SalaryAdvanceListStore";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "37px",
    minHeight: "37px",
    width: "200px",
    fontSize: "13px",
    fontFamily: "Inter",
    fontWeight: "400",
  }),
};

export default function Selector({ param, property }) {
  const { updateParams, loadItems, queryParams, setLoading } =
    useSalaryAdvanceListStore();
  const { t } = useTranslation();
  const options = useMemo(() => {
    return (
      param?.map((element) => ({
        label: element.name,
        value: property == t("To'lov turi") ? element.value : element.id,
      })) || []
    );
  }, [param]);

  const handleSelectChange = useCallback(async (e) => {
    setLoading(true);
    if (property === t("O'qituvchilar")) {
      updateParams({ staff: e?.value == undefined ? "" : e?.value, page: 1 });
      await loadItems(
        new URLSearchParams({
          ...queryParams,
          staff: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    if (property === t("Filiallar")) {
      updateParams({ branch: e?.value == undefined ? "" : e?.value, page: 1 });
      await loadItems(
        new URLSearchParams({
          ...queryParams,
          branch: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    if (property === t("To'lov turi")) {
      updateParams({
        payment_mode: e?.value == undefined ? "" : e?.value,
        page: 1,
      });
      await loadItems(
        new URLSearchParams({
          ...queryParams,
          payment_mode: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    setLoading(false);
  });

  return (
    <div className="normal-select-bar">
      <Select
        className="basic-single manage_group_select"
        classNamePrefix="select"
        placeholder={property}
        styles={customStyles}
        options={options}
        isClearable
        onChange={handleSelectChange}
      />
    </div>
  );
}
